import { Img, Text } from "@react-email/components";
import { Layout, OrderSection, StyledButton } from "./components";

/**
 * @param orderDate Date Object
 * @param productList Array of objects with properties for each product: img, name, quantity, price. If price doesn't exist, it will be displayed as FREE
 * @param prices An object with the following properties: subtotal, tax, shipping, total. If the prices object doesn't exist, it will not generate the price section
 * @param address String
 */
export default function FreeSwatches({
	orderDate,
	orderNumber,
	productList,
	address,
	name,
	shippingType,
	phoneNumber,
}) {
	const utm_campaign = "free_swatches_response";

	return (
		<Layout
			withNavBar
			utm_campaign={utm_campaign}
			preview="Thank you for ordering swatches!"
		>
			<Img
				src="https://offcutshades.com/images/email/swatches_greyscale.gif"
				alt="Samples"
				width="100%"
			/>
			<Text>
				Thanks for ordering swatches. We are curious to know which one will end
				on your windows.
			</Text>
			<Text>
				<b>We'll ship your order in the next 48 business hours.</b> Meanwhile,
				get ready to decide.
			</Text>
			<Text>
				When you get your swatches, compare the textures, place them on your
				windows to test the opacity and privacy levels, and check how the
				colours coordinate with your current decoration.
			</Text>
			<br />
			<br />
			<OrderSection
				orderDate={orderDate}
				orderNumber={orderNumber}
				productList={productList}
				address={address}
				name={name}
				phoneNumber={phoneNumber}
				shippingType={shippingType}
			/>
			<h2>We are here to help you</h2>
			<StyledButton
				link={"https://offcutshades.com/shop/fabric-details"}
				text="Fabric Guide"
			/>
			<Text>
				If you have any questions, please don't hesitate to{" "}
				<a
					href={`https://offcutshades.com/contact?utm_source=body&utm_medium=email&utm_campaign=${utm_campaign}&utm_id=ATemails`}
					style={{ color: "#ef4036" }}
				>
					contact us
				</a>
				.
			</Text>
		</Layout>
	);
}
